export default __webpack_public_path__ + "static/media/14.6c90cbc4.jpg";